const JOB_TYPE_ACTIONS = {
  //get job type
  GET_JOB_TYPE: "GET_JOB_TYPE",
  GET_JOB_TYPE_SUCCESS: "GET_JOB_TYPE_SUCCESS",
  GET_JOB_TYPE_FAIL: "GET_JOB_TYPE_FAIL",
  //add job type
  ADD_JOB_TYPE_REQUEST: "ADD_JOB_TYPE_REQUEST",
  ADD_JOB_TYPE_REQUEST_SUCCESS: "ADD_JOB_TYPE_REQUEST_SUCCESS",
  ADD_JOB_TYPE_REQUEST_FAIL: "ADD_JOB_TYPE_REQUEST_FAIL",
  //update job type
  UPDATE_JOB_TYPE_REQUEST: "UPDATE_JOB_TYPE_REQUEST",
  UPDATE_JOB_TYPE_REQUEST_SUCCESS: "UPDATE_JOB_TYPE_REQUEST_SUCCESS",
  UPDATE_JOB_TYPE_REQUEST_FAIL: "UPDATE_JOB_TYPE_REQUEST_FAIL",
  //delete job type
  DELETE_JOB_TYPE: "DELETE_JOB_TYPE",
  DELETE_JOB_TYPE_SUCCESS: "DELETE_JOB_TYPE_SUCCESS",
  DELETE_JOB_TYPE_FAIL: "DELETE_JOB_TYPE_FAIL",
};
export default JOB_TYPE_ACTIONS;
